import React from "react";
import ReactDOM from "react-dom";

/**
 * 参考图 hover 大图预览（参照 VpMentionPreview 模式）
 * 使用 Portal 渲染到 body，fixed 定位，智能左右判断
 */
const RefImagePreview = React.memo(({ url, anchorEl }) => {
  if (!url || !anchorEl) return null;
  const rect = anchorEl.getBoundingClientRect();
  if (!rect) return null;

  const previewWidth = Math.min(400, window.innerWidth * 0.3) + 20;
  const spaceRight = window.innerWidth - rect.right;
  const pos = spaceRight >= previewWidth
    ? { left: rect.right + 8, right: "auto" }
    : { right: window.innerWidth - rect.left + 8, left: "auto" };

  // 垂直居中于 anchor
  const top = Math.max(8, rect.top + rect.height / 2 - 150);

  return ReactDOM.createPortal(
    <div className="fixed z-[400] pointer-events-none" style={{ ...pos, top }}>
      <img
        src={url}
        alt=""
        className="rounded-xl shadow-2xl animate-in fade-in zoom-in-95 duration-150"
        style={{
          maxWidth: "min(400px, 30vw)",
          maxHeight: "min(400px, 40vh)",
          width: "auto",
          height: "auto",
          objectFit: "contain",
          backgroundColor: "var(--color-bg-secondary)",
          border: "1px solid var(--color-border-primary)",
          padding: "4px",
        }}
      />
    </div>,
    document.body
  );
});

export default RefImagePreview;
